import {Component , Inject , OnInit , ViewEncapsulation} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {FrontUserService} from '../../../../../core/services/frontUsers.service';
import {OrganizationsService} from '../../../../../core/services/organizations.service';
import {checkEmailOnServer , emailValidator} from '../../../../../core/validators/validators';
import * as _ from 'lodash';
import {TranslateService} from '@ngx-translate/core';
import { ToastrService  } from 'ngx-toastr';
import {GenderFuncService} from '../../../../../core/services/genderFunc.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import moment from 'moment';

@Component({
    selector: 'front-user-setting-form-dialog',
    templateUrl: './setting-form.component.html',
    styleUrls: ['./setting-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class FrontUserFormDialogComponent implements OnInit {
  public formGroup: FormGroup = new FormGroup({
    duplicateAddress: new FormControl(''),
    frontRoleId: new FormControl({value: '', disabled: true}, Validators.required),
    firstName: new FormControl({value: '', disabled: true}, Validators.required),
    lastName: new FormControl({value: '', disabled: true}, Validators.required),
    nickName: new FormControl({value: '', disabled: true}),
    email: new FormControl({value: '', disabled: true}, [emailValidator , checkEmailOnServer]),
    countryId: new FormControl({value: '', disabled: true}, Validators.required),
    cityId: new FormControl({value: '', disabled: true}, Validators.required),
    organizationId: new FormControl({value: '', disabled: true}, Validators.required),
    lang: new FormControl({value: '', disabled: true}, Validators.required),
    gender: new FormControl({value: '', disabled: true}, Validators.required),
    genderType: new FormControl({value: '', disabled: true}, Validators.required),
    street: new FormControl({value: '', disabled: true}),
    number: new FormControl({value: '', disabled: true}),
    postcode: new FormControl({value: '', disabled: true}),
    cityLocation: new FormControl({value: '', disabled: true}),
    phone: new FormControl({value: '', disabled: true}),
    mobile: new FormControl({value: '', disabled: true}),
    dateOfBirth: new FormControl({value: null, disabled: true}),
    abschlussjahr: new FormControl({value: '', disabled: true}),
    dateOfBaptism: new FormControl({value: '', disabled: true}),
    targetGroupId: new FormControl({value: '', disabled: true}),
    representative: new FormControl({value: '', disabled: true}),
    status: new FormControl({value: '', disabled: true}),
    confessionId: new FormControl({value: '', disabled: true}),
    notes: new FormControl({value: '', disabled: true}),
    id: new FormControl({value: '', disabled: true})
  });
  public copyForm;
  public hideForm;
  action: string;
  dialogTitle;
  frontUser;
  mainUser;
  public countries = [];
  public cities = [];
  public organizations = [];
  public targetGroups = [];
  public roles = [];
  type;
  existUser;
  parentType;
  setDuplicateAddress = false;

  oldRole;
  genders = [ {label: 'Mann' , value: 'male'} , {label: 'Frau' , value: 'female'}, {label: 'Divers' , value: 'diverse'} ];
  genderTypes = [];
  levelStatuses = [];
  confessions = [];
  public languages = [ {label: 'English' , value: 'en'} , {label: 'Deutsch' , value: 'de'}, {label: 'Français' , value: 'fr'} ];
  userRole;

  constructor (public dialogRef: MatDialogRef<FrontUserFormDialogComponent> ,
               @Inject(MAT_DIALOG_DATA) private data: any , public toastr: ToastrService ,
               private userService: FrontUserService ,
               private organizationService: OrganizationsService, public translate: TranslateService,
               public genderService: GenderFuncService, public snackBar: MatSnackBar) {
    this.organizationService.getCountry().subscribe((result: any) => {
      this.countries = result;
      if (this.frontUser && this.frontUser.countryId) {
        this.formGroup.patchValue({countryId: this.frontUser.countryId});
      }
      this.userService.getRoles().subscribe((roleResult: any) => {
        this.roles = [];
        for (let i = 0; i < roleResult.length; i++) {
          let translation = translate.instant('main._' + roleResult[ i ].name);
          this.roles.push({value: roleResult[ i ].id , label: translation});
        }
        this.userService.getLevelStatus().subscribe((levelResult: any) => {
          this.levelStatuses = [];
          for (let i = 0; i < levelResult.length; i++) {
            if (levelResult[ i ].status) {
              this.levelStatuses.push({
                value: levelResult[ i ].id ,
                label: (levelResult[ i ].level + '/' + levelResult[ i ].status)
              });
            } else {
              this.levelStatuses.push({value: levelResult[ i ].id , label: (levelResult[ i ].level)});
            }
          }
          this.userService.getTargetGroup(false).subscribe((targetResults: any) => {
            this.targetGroups = [];
            for (let i = 0; i < targetResults.targetGroups.length; i++) {
              this.targetGroups.push({
                value: targetResults.targetGroups[ i ].id ,
                label: ((('0' + targetResults.targetGroups[ i ].targetNumber).slice(-2)) + ' - ' + targetResults.targetGroups[ i ].ageMask)

              });
            }
            this.userService.getConfession().subscribe((confessioResults: any) => {
              this.confessions = confessioResults;
              this.oldRole = data.role;
              this.type = data.type;
              this.action = data.action;
              this.frontUser = Object.assign({}, data.data);
              this.mainUser = Object.assign({}, data.userData);
              this.parentType = data.parentType;
              if (data.userRole) {
                this.userRole = data.userRole;
              }
              if (this.action === 'new') {
                this.dialogTitle = 'frontUser.add_new_' + (data.ageType === 'adult' ? 'parent' : 'student');
              }
              if (this.action === 'edit') {
                this.dialogTitle = 'frontUser.edit_' + (data.ageType === 'adult' ? 'parent' : 'student');
              }
              this.initForm();
            });
          });
        });
      });
    });
  }

  ngOnInit () {
  }

  initForm () {
    if (this.countries) {
      if (this.frontUser && this.frontUser.countryId) {
        this.formGroup.patchValue({countryId: this.frontUser.countryId});
      }
    }
    this.formGroup.get('countryId').valueChanges.subscribe((res) => {
      if (res) {
        this.organizationService.getCity(res).subscribe((result: any) => {
          this.cities = result;
          if (this.setDuplicateAddress) {
            this.formGroup.patchValue({cityId: this.mainUser.cityId});
          }
          if (this.frontUser && this.frontUser.cityId) {
            this.formGroup.patchValue({cityId: this.frontUser.cityId});
          }
        });
      }
    });

    this.formGroup.get('cityId').valueChanges.subscribe((res) => {
      if (res) {
        this.organizationService.getOrganizationByCity(res).subscribe((result: any) => {
          this.organizations = result;
          if (this.setDuplicateAddress) {
            this.formGroup.patchValue({organizationId: this.mainUser.organizationId});
          }
          if (this.frontUser && this.frontUser.organizationId) {
            this.formGroup.patchValue({organizationId: this.frontUser.organizationId});
          }
        });
      }
    });
    this.formGroup.get('duplicateAddress').valueChanges.subscribe((res) => {
      if (this.action === 'new') {
        this.setDuplicateAddress = res;
        if (res) {
          this.formGroup.patchValue({street: this.mainUser.street});
          this.formGroup.patchValue({number: this.mainUser.number});
          this.formGroup.patchValue({postcode: this.mainUser.postcode});
          this.formGroup.patchValue({cityLocation: this.mainUser.cityLocation});
          this.formGroup.patchValue({phone: this.mainUser.phone});
          this.formGroup.patchValue({countryId: this.mainUser.countryId});
          this.formGroup.patchValue({cityId: this.mainUser.cityId});
          this.formGroup.patchValue({organizationId: this.mainUser.organizationId});
        } else {
          this.formGroup.patchValue({street: null});
          this.formGroup.patchValue({number: null});
          this.formGroup.patchValue({postcode: null});
          this.formGroup.patchValue({cityLocation: null});
          this.formGroup.patchValue({phone: null});
          this.formGroup.patchValue({countryId: null});
          this.formGroup.patchValue({cityId: null});
          this.formGroup.patchValue({organizationId: null});
        }
      }
    });
    this.formGroup.get('frontRoleId').valueChanges.subscribe((res) => {
      const selectControlCountry = this.formGroup.get('countryId');
      const selectControlTargetGroup = this.formGroup.get('targetGroupId');
      const selectControlConfession = this.formGroup.get('confessionId');
      const selectControlCanton = this.formGroup.get('cityId');
      const selectControlOrganization = this.formGroup.get('organizationId');
      const selectControlGender = this.formGroup.get('gender');
      const selectControlGenderType = this.formGroup.get('genderType');
      const selectControlLang = this.formGroup.get('lang');
      const inputControlFirstName = this.formGroup.get('firstName');
      const inputControlLastName = this.formGroup.get('lastName');
      const inputControlNickName = this.formGroup.get('nickName');
      const inputControlStreet = this.formGroup.get('street');
      const inputControlNumber = this.formGroup.get('number');
      const inputControlPostcode = this.formGroup.get('postcode');
      const inputControlCity = this.formGroup.get('cityLocation');
      const inputControlPhone: any = this.formGroup.get('phone');
      const inputControlMobile: any = this.formGroup.get('mobile');
      const inputControlEmail = this.formGroup.get('email');
      const inputControlDateOfBirth = this.formGroup.get('dateOfBirth');
      const inputControlDateOfBaptism = this.formGroup.get('dateOfBaptism');
      const inputControlNotes = this.formGroup.get('notes');
      const inputControlAbschlussjahr = this.formGroup.get('abschlussjahr');
      const inputControlStatus = this.formGroup.get('status');
      const inputControlAutofillAddress = this.formGroup.get('duplicateAddress');
      const checkboxRepresentative = this.formGroup.get('representative');
      let _genders = JSON.parse(JSON.stringify(this.genderTypes));
      if (res) {
        if (res === 1) {
          if (this.type === 'parent') {
            _genders = _genders.filter(el => el.isChild);
          } else {
            _genders = _genders.filter(el => !el.isAdult && !el.isChild);
          }
        } else if (res === 2) {
          if (this.type === 'parent') {
            _genders = _genders.filter(el => !el.isChild && !el.isAdult);
          } else {
            _genders = _genders.filter(el => el.isAdult);
          }
        }
      }
      this.genderTypes = _genders;

      if (res === 1) {
        selectControlCountry.enable({emitEvent: false});
        selectControlCanton.enable({emitEvent: false});
        selectControlOrganization.enable({emitEvent: false});
        inputControlFirstName.enable();
        inputControlLastName.enable();
        inputControlNickName.enable();
        inputControlEmail.enable({emitEvent: false});
        selectControlLang.enable();

        selectControlGender.enable();
        selectControlGenderType.enable();
        inputControlStreet.enable();
        inputControlNumber.enable();
        inputControlPostcode.enable();
        inputControlCity.enable();
        inputControlPhone.enable();
        inputControlMobile.enable();
        inputControlDateOfBirth.enable();

        inputControlDateOfBaptism.enable();
        inputControlNotes.enable();
        inputControlAbschlussjahr.enable();
        inputControlStatus.enable();
        selectControlTargetGroup.enable();
        selectControlConfession.enable();
        selectControlTargetGroup.enable();
        if (this.action === 'new') {
          inputControlAutofillAddress.enable();
        }
      } else if (res === 2) {
        selectControlCountry.enable({emitEvent: false});
        selectControlCanton.enable({emitEvent: false});
        selectControlOrganization.enable({emitEvent: false});
        inputControlFirstName.enable();
        inputControlLastName.enable();
        inputControlNickName.disable();
        inputControlEmail.enable({emitEvent: false});
        selectControlLang.enable();

        selectControlGender.enable();
        selectControlGenderType.enable();
        inputControlStreet.enable();
        inputControlNumber.enable();
        inputControlPostcode.enable();
        inputControlCity.enable();
        inputControlPhone.enable();
        inputControlMobile.enable();
        inputControlDateOfBirth.enable();

        inputControlDateOfBaptism.disable();
        // inputControlDetailOfTargetGroup.disable();
        inputControlNotes.enable();
        inputControlAbschlussjahr.disable();
        inputControlStatus.enable();
        selectControlTargetGroup.enable();
        selectControlConfession.enable();
        selectControlTargetGroup.disable();
        checkboxRepresentative.enable();
        this.formGroup.patchValue({targetGroupId: this.targetGroups[ this.targetGroups.length - 1 ].value});
        if (this.action === 'new') {
          selectControlTargetGroup.disable();
          inputControlAutofillAddress.enable();
        }
      }
    });

    if (this.action === 'edit') {
      const selectControlRole = this.formGroup.get('frontRoleId');
      selectControlRole.disable();
      if (this.frontUser.status) {
        this.frontUser.status = this.frontUser.status.split(',');
        for (let i = 0; i < this.frontUser.status.length; i++) {
          this.frontUser.status[ i ] = parseInt(this.frontUser.status[ i ] , 10);
        }
      }
      if (this.frontUser.dateOfBirth) {
        let date = this.frontUser.dateOfBirth;
        let m = moment(date, 'DD.MM.YYYY', true);
        if (!m.isValid()) {
          m = moment(date);
        }
        this.frontUser.dateOfBirth = m.toDate();
      }
      if (this.frontUser.dateOfBaptism) {
        let date = this.frontUser.dateOfBaptism;
        let m = moment(date, 'DD.MM.YYYY', true);
        if (!m.isValid()) {
          m = moment(date);
        }
        this.frontUser.dateOfBaptism = m.toDate();
      }
      this.formGroup.patchValue(this.frontUser);
    }
    if (this.parentType) {
      if (this.parentType === 'motherId' || this.parentType === 'godMotherId') {
        this.formGroup.patchValue({gender: 'female'});
      }
      if (this.parentType === 'fatherId' || this.parentType === 'godFatherId') {
        this.formGroup.patchValue({gender: 'male'});
      }
    }
    if (this.action === 'new') {
      this.formGroup.get('email').valueChanges.subscribe(res => {
        if (res) {
          const errors = this.formGroup.controls.email.errors;
          if (!errors) {
            this.userService.checkEmailValid(res , this.mainUser.email).subscribe((data: any) => {
              if (data.valid && data.user && !this.hideForm) {
                if (+this.userRole === +data.user.frontRoleId) {
                  this.existUser = data.user;
                  this.formGroup.controls.email.setErrors({checkEmailOnServer: true});
                  this.hideForm = true;
                  this.dialogTitle = 'frontUser.connect_' + this.type;
                  this.copyForm = _.cloneDeep(this.formGroup);
                  if (data.user && data.user.status) {
                    data.user.status = data.user.status.split(',');
                    for (let i = 0; i < data.user.status.length; i++) {
                      data.user.status[ i ] = parseInt(data.user.status[ i ] , 10);
                    }
                  }

                  if (data.user) {
                    this.formGroup.patchValue(data.user);
                    if (data.dateOfBirth) {
                      data.dateOfBirth = new Date(data.dateOfBirth);
                    }
                    if (data.dateOfBaptism) {
                      data.dateOfBaptism = new Date(data.dateOfBaptism);
                    }
                    const selectControlCountry = this.formGroup.get('countryId');
                    const selectControlTargetGroup = this.formGroup.get('targetGroupId');
                    const selectControlConfession = this.formGroup.get('confessionId');
                    const selectControlCanton = this.formGroup.get('cityId');
                    const selectControlOrganization = this.formGroup.get('organizationId');
                    const selectControlGender = this.formGroup.get('gender');
                    const selectControlGenderType = this.formGroup.get('genderType');
                    const selectControlLang = this.formGroup.get('lang');
                    const inputControlFirstName = this.formGroup.get('firstName');
                    const inputControlLastName = this.formGroup.get('lastName');
                    const inputControlNickName = this.formGroup.get('nickName');
                    const inputControlStreet = this.formGroup.get('street');
                    const inputControlNumber = this.formGroup.get('number');
                    const inputControlPostcode = this.formGroup.get('postcode');
                    const inputControlCity = this.formGroup.get('cityLocation');
                    const inputControlPhone = this.formGroup.get('phone');
                    const inputControlMobile = this.formGroup.get('mobile');
                    const inputControlEmail = this.formGroup.get('email');
                    const inputControlDateOfBirth = this.formGroup.get('dateOfBirth');
                    const inputControlDateOfBaptism = this.formGroup.get('dateOfBaptism');
                    const inputControlAbschlussjahr = this.formGroup.get('abschlussjahr');
                    const inputControlStatus = this.formGroup.get('status');
                    const inputControlAutofillAddress = this.formGroup.get('duplicateAddress');
                    selectControlCountry.disable({emitEvent: false});
                    selectControlCanton.disable({emitEvent: false});
                    selectControlOrganization.disable({emitEvent: false});
                    inputControlFirstName.disable();
                    inputControlLastName.disable();
                    inputControlNickName.disable();
                    inputControlEmail.disable({emitEvent: false});
                    selectControlLang.disable();

                    selectControlGender.disable();
                    selectControlGenderType.enable();
                    inputControlStreet.disable();
                    inputControlNumber.disable();
                    inputControlPostcode.disable();
                    inputControlCity.disable();
                    inputControlPhone.disable();
                    inputControlMobile.disable();
                    inputControlDateOfBirth.disable();

                    inputControlDateOfBaptism.disable();
                    inputControlAbschlussjahr.disable();
                    inputControlStatus.disable();
                    selectControlTargetGroup.disable();
                    selectControlConfession.disable();

                    inputControlAutofillAddress.disable();
                  }
                } else {
                  let text = '';
                  if (+this.userRole === 1) {
                    text = this.translate.instant('user_is_not_child');
                  } else if (+this.userRole === 2){
                    text = this.translate.instant('user_is_not_adult');
                  }
                  this.snackBar.open(text , '' , {duration: 10000});
                  this.formGroup.patchValue({email: ''});
                }
              }
              if (!data.valid) {
                this.formGroup.controls.email.setErrors({checkEmailOnServer: true});
              }
            });
          }
        }
      });
    }
    if (this.userRole) {
      this.formGroup.patchValue({frontRoleId: +this.userRole});
    }
    this.getGenders();
  }

  getGenders() {
    this.genderService.findAvailable().subscribe((res: any) => {
      if (res) {
        let role;
        if (this.formGroup && this.formGroup.getRawValue() && this.formGroup.getRawValue().frontRoleId) {
          role = +this.formGroup.getRawValue().frontRoleId;
        }
        if (role) {
          if (role === 1) {
            if (this.type === 'parent') {
              res = res.filter(el => el.isChild);
            } else {
              res = res.filter(el => !el.isAdult && !el.isChild && !el.onlyForAdult);
            }
          } else if (role === 2) {
            if (this.type === 'parent') {
              res = res.filter(el => !el.isChild && !el.isAdult);
            } else {
              res = res.filter(el => el.isAdult && !el.onlyForAdult);
            }
          }
        }
        this.genderTypes = res;
        if (this.frontUser && this.frontUser.genderTypeId) {
          this.formGroup.patchValue({genderType: this.frontUser.genderTypeId});
        } else {
          let defGT = res.find(gt => gt.defaultType === this.oldRole);
          if (defGT) {
            this.formGroup.patchValue({genderType: defGT.id});
          }
        }
      }
    });
  }

  backForm () {
    this.copyForm.patchValue({email: ''});
    this.formGroup = this.copyForm;
    this.formGroup = _.cloneDeep(this.copyForm);
    this.hideForm = false;
    const selectControlCountry = this.formGroup.get('countryId');
    const selectControlCanton = this.formGroup.get('cityId');
    const selectControlOrganization = this.formGroup.get('organizationId');
    const selectControlGender = this.formGroup.get('gender');
    const selectControlGenderType = this.formGroup.get('genderType');
    const selectControlLang = this.formGroup.get('lang');
    const inputControlFirstName = this.formGroup.get('firstName');
    const inputControlLastName = this.formGroup.get('lastName');
    const inputControlNickName = this.formGroup.get('nickName');
    const inputControlStreet = this.formGroup.get('street');
    const inputControlNumber = this.formGroup.get('number');
    const inputControlPostcode = this.formGroup.get('postcode');
    const inputControlCity = this.formGroup.get('cityLocation');
    const inputControlPhone: any = this.formGroup.get('phone');
    const inputControlMobile: any = this.formGroup.get('mobile');
    const inputControlEmail = this.formGroup.get('email');
    const inputControlDateOfBirth = this.formGroup.get('dateOfBirth');
    const inputControlAutofillAddress = this.formGroup.get('duplicateAddress');
    const inputControlDateOfBaptism = this.formGroup.get('dateOfBaptism');
    const inputControlNotes = this.formGroup.get('notes');
    const inputControlAbschlussjahr = this.formGroup.get('abschlussjahr');
    const inputControlStatus = this.formGroup.get('status');
    const selectControlTargetGroup = this.formGroup.get('targetGroupId');
    const selectControlConfession = this.formGroup.get('confessionId');
    selectControlCountry.enable({emitEvent: false});
    selectControlCanton.enable({emitEvent: false});
    selectControlOrganization.enable({emitEvent: false});
    inputControlFirstName.enable();
    inputControlLastName.enable();
    inputControlNickName.enable();
    inputControlEmail.enable({emitEvent: false});
    selectControlLang.enable();

    selectControlGender.enable();
    selectControlGenderType.enable();
    inputControlStreet.enable();
    inputControlNumber.enable();
    inputControlPostcode.enable();
    inputControlCity.enable();
    inputControlPhone.enable();
    inputControlMobile.enable();
    inputControlDateOfBirth.enable();

    inputControlDateOfBaptism.enable();
    inputControlNotes.enable();
    inputControlAbschlussjahr.enable();
    inputControlStatus.enable();
    selectControlTargetGroup.enable();
    selectControlConfession.enable();

    inputControlAutofillAddress.enable();
    if (this.action === 'new') {
      this.dialogTitle = 'Add new ' + this.type;
    }
    if (this.action === 'edit') {
      this.dialogTitle = 'Edit  ' + this.type;
    }
  }

  saveUser(data) {
    data[0].gender = this.genderTypes.find(el => +el.id === + this.formGroup.getRawValue().genderType);
    // if (data[1] === 'connect') {
      data[0].genderType = this.formGroup.getRawValue().genderType;
      data[0].value = {representative: false};
      data[0].value.representative = this.formGroup.getRawValue().hasOwnProperty('representative') ? this.formGroup.getRawValue().representative : false;
    //   this.dialogRef.close(data);
    // } else {
    if (data[1] === 'connect') {
      this.dialogRef.close(data);
      return;
    }
      if (data[0].value.phone) {
        data[0].value.phone = data[0].value.phone.slice(0 , 16).replace(/_/g, '');
        let checkPhone = data[0].value.phone.replace(/\+/g, '').replace(/ /g, '');
        if (!checkPhone) {
          data[0].value.phone = '';
        }
      }
      if (data[0].value.mobile) {
        data[0].value.mobile = data[0].value.mobile.slice(0 , 16).replace(/_/g, '');
        let checkMobile = data[0].value.mobile.replace(/\+/g, '').replace(/ /g, '');
        if (!checkMobile) {
          data[0].value.mobile = '';
        }
      }
      if (data[0].controls['dateOfBirth'].value) {
        data[0].value.dateOfBirth = data[0].controls['dateOfBirth'].value;
      }
      if (data[0].controls['dateOfBaptism'].value) {
        data[0].value.dateOfBaptism = data[0].controls['dateOfBaptism'].value;
      }
      if (data[0].value.phone && data[0].value.phone.length < 14) {
        this.toastr.error('Enter correct phone number' , 'Error!');
      } else if (data[0].value.mobile && data[0].value.mobile.length < 14) {
        this.toastr.error('Enter correct mobile number' , 'Error!');
      } else {
        this.dialogRef.close(data);
      }
    // }
  }
}
